module.exports = __webpack_public_path__ + "img/gb.8399ef73.png";